/* ==========================================================================
   nc-flavor-select — 商品画像つきフレーバー選択ドロップダウン

   設計の前提（崩すとカートが壊れる）:
   - ネイティブ <select> が唯一の真実。name="properties[POD1]" 等のまま
     フォームに残っており、FormData に載るのはこの select。
   - セクション側のロジックは select.value / select.disabled / select.focus()
     と change イベントに依存している（個数連動の disabled、送信前バリデーション、
     エラー表示のクリア）。このスクリプトは select を「操作する側」に徹して、
     選択のたびに change を bubbles: true で発火させる。
   - JS が落ちた場合は .is-ready が付かず、素の <select> がそのまま使える。
   ========================================================================== */
(function () {
  'use strict';

  var OPEN = null; // 同時に開くのは1つだけ

  function closeOpen(except) {
    if (OPEN && OPEN.root !== except) OPEN.close();
    if (OPEN && OPEN.root === except) return;
    OPEN = null;
  }

  function init(root) {
    if (!root || root.dataset.fselReady === '1') return;

    var select = root.querySelector('.nc-fsel__native');
    var trigger = root.querySelector('.nc-fsel__trigger');
    var menu = root.querySelector('.nc-fsel__menu');
    var labelEl = root.querySelector('[data-fsel-label]');
    var thumbEl = root.querySelector('[data-fsel-thumb]');
    if (!select || !trigger || !menu) return;

    var opts = Array.prototype.slice.call(menu.querySelectorAll('.nc-fsel__opt'));
    var selectable = opts.filter(function (o) {
      return o.getAttribute('aria-disabled') !== 'true';
    });
    var placeholder = trigger.getAttribute('data-fsel-placeholder') || '選択してください';
    var activeIdx = -1;

    root.dataset.fselReady = '1';
    root.classList.add('is-ready');
    // JS が動いたときだけタブ順から外す（未初期化なら素の select がそのまま使える）
    select.setAttribute('tabindex', '-1');

    /* --- select → UI 同期 -------------------------------------------------- */
    function syncFromSelect() {
      var value = select.value;
      var match = null;
      for (var i = 0; i < opts.length; i++) {
        var hit = opts[i].getAttribute('data-fsel-value') === value && value !== '';
        opts[i].setAttribute('aria-selected', hit ? 'true' : 'false');
        if (hit) match = opts[i];
      }
      root.classList.toggle('is-filled', !!match);
      if (labelEl) labelEl.textContent = match ? match.getAttribute('data-fsel-label') : placeholder;
      if (thumbEl) {
        var img = match ? match.getAttribute('data-fsel-thumb') : '';
        thumbEl.style.backgroundImage = img ? 'url("' + img + '")' : '';
      }
    }

    /* --- 開閉 -------------------------------------------------------------- */
    function setActive(i) {
      if (activeIdx > -1 && opts[activeIdx]) opts[activeIdx].classList.remove('is-active');
      activeIdx = i;
      if (activeIdx > -1 && opts[activeIdx]) {
        opts[activeIdx].classList.add('is-active');
        var el = opts[activeIdx];
        var top = el.offsetTop;
        var bottom = top + el.offsetHeight;
        if (top < menu.scrollTop) menu.scrollTop = top;
        else if (bottom > menu.scrollTop + menu.clientHeight) menu.scrollTop = bottom - menu.clientHeight;
      }
    }

    function open() {
      if (root.classList.contains('is-open')) return;
      closeOpen(root);
      menu.hidden = false;
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      // 画面下に収まらないときは上に開く
      var rect = trigger.getBoundingClientRect();
      var below = window.innerHeight - rect.bottom;
      menu.classList.toggle('is-up', below < Math.min(menu.scrollHeight + 16, 300) && rect.top > below);
      var sel = opts.indexOf(menu.querySelector('.nc-fsel__opt[aria-selected="true"]'));
      setActive(sel > -1 ? sel : (selectable.length ? opts.indexOf(selectable[0]) : -1));
      OPEN = { root: root, close: close };
    }

    function close() {
      if (!root.classList.contains('is-open')) return;
      menu.hidden = true;
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      setActive(-1);
      if (OPEN && OPEN.root === root) OPEN = null;
    }

    function choose(opt) {
      if (!opt || opt.getAttribute('aria-disabled') === 'true') return;
      select.value = opt.getAttribute('data-fsel-value');
      // セクション側のバリデーション解除・エラー消しはこの change に依存している
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncFromSelect();
      close();
      trigger.focus();
    }

    /* --- イベント ---------------------------------------------------------- */
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (root.classList.contains('is-open')) close();
      else open();
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
        menu.focus();
      }
    });

    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        trigger.focus();
        return;
      }
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        choose(opts[activeIdx]);
        return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
      e.preventDefault();
      if (!selectable.length) return;
      var pos = selectable.indexOf(opts[activeIdx]);
      if (e.key === 'Home') pos = 0;
      else if (e.key === 'End') pos = selectable.length - 1;
      else if (e.key === 'ArrowDown') pos = pos < 0 ? 0 : Math.min(pos + 1, selectable.length - 1);
      else pos = pos <= 0 ? 0 : pos - 1;
      setActive(opts.indexOf(selectable[pos]));
    });

    opts.forEach(function (opt, i) {
      opt.addEventListener('click', function () { choose(opt); });
      opt.addEventListener('mousemove', function () {
        if (opt.getAttribute('aria-disabled') !== 'true' && activeIdx !== i) setActive(i);
      });
    });

    // ネイティブ select が外部から変更された場合も追随（保険）
    select.addEventListener('change', syncFromSelect);
    // バリデーション失敗時の select.focus() は不可視なのでトリガーへ転送
    select.addEventListener('focus', function () { trigger.focus(); });

    syncFromSelect();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.nc-fsel').forEach(init);
  }

  document.addEventListener('click', function (e) {
    if (!OPEN) return;
    if (!OPEN.root.contains(e.target)) closeOpen(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && OPEN) closeOpen(null);
  });

  window.addEventListener('resize', function () { if (OPEN) closeOpen(null); });

  initAll(document);
  // テーマエディタでのセクション再描画
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
